import React from 'react';

import { Filler, ProgressBarContainer } from './scoringStyle';

const PointBar = ({
  value,
  maxValue,
  width = '319px',
}: {
  value: number;
  maxValue: number;
  width?: string;
}) => {
  const progressPercentage = (value / maxValue) * 100;

  return (
    <ProgressBarContainer width={width}>
      <Filler progress={progressPercentage} />
    </ProgressBarContainer>
  );
};

export default PointBar;
